const DEFAULT_RECHECK_DELAY_MS = 200;

async function probeAuthPortalSession(fetchImpl) {
  const host = process.env.authUrl && process.env.authUrl !== 'undefined' ? process.env.authUrl : 'auth-qa.netgear.com';
  try {
    const response = await fetchImpl(`https://${host}/v1/auth/me`, {
      method: 'GET',
      credentials: 'include',
    });
    return Boolean(response && response.ok);
  } catch {
    return false;
  }
}

function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * Live OC v3 session check. HttpOnly cookies are not readable from JS;
 * leftover Insight `_Id` / accountId cookies are not proof of an OC session.
 */
export async function isAuthPortalSessionAlive(fetchImpl = fetch) {
  return probeAuthPortalSession(fetchImpl);
}

/**
 * Re-probe auth/me after a short delay when the first check succeeds.
 * Credential-change logout can leave auth/me briefly 200 before OC tears down the session.
 */
export async function isAuthPortalSessionAliveWithRecheck(
  fetchImpl = fetch,
  { delayMs = DEFAULT_RECHECK_DELAY_MS } = {}
) {
  const firstAlive = await probeAuthPortalSession(fetchImpl);
  if (!firstAlive) {
    return false;
  }
  if (delayMs > 0) {
    await delay(delayMs);
  }
  return probeAuthPortalSession(fetchImpl);
}
